import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=b65e7cac&scoped=true"
import script from "./SubMenu.js?vue&type=script&lang=js&external"
export * from "./SubMenu.js?vue&type=script&lang=js&external"
import style0 from "./SubMenu.scss?vue&type=style&index=0&id=b65e7cac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65e7cac",
  null
  
)

export default component.exports